import axios from 'axios';
import React, { createContext, useContext, useState, useEffect } from 'react';
import { useLoading } from '../contexts/LoadingContext';
import { useAuth } from './AuthSkillContext';
import { signInAnonymously } from 'firebase/auth';


const TranslationContext = createContext();

export const useTranslations = () => useContext(TranslationContext);

export const TranslationProvider = ({ children}) => {
    const { showLoading, hideLoading } = useLoading();
    const [language, setLanguage] = useState('Polish');
    const [languagePost, setLanguagePost] = useState('Polish');
    const [translations, setTranslations] = useState({});
    const { currentUser } = useAuth();

    



    const translate = (key, fallback = '') => {
        const result = translations[key];
        return result || fallback;
    };

    const value = {
        language,
        languagePost,
        setLanguage,
        setLanguagePost,
        translations,
        translate
    };

    return (
        <TranslationContext.Provider value={value}>
            {children}
        </TranslationContext.Provider>
    );
};
